<h2 mat-dialog-title>{{ isEdit ? 'Editar categoría' : 'Nueva categoría' }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="category-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Nombre</mat-label>
      <input matInput formControlName="name" maxlength="60" />
      <mat-error *ngIf="form.get('name')?.hasError('required')">El nombre es requerido</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Icono (Material Icons)</mat-label>
      <input matInput formControlName="iconName" placeholder="ej: cleaning_services_rounded" />
      <mat-icon matSuffix>{{ form.get('iconName')?.value || 'category' }}</mat-icon>
      <mat-hint>Nombre del icono de Material que usa el app móvil</mat-hint>
      <mat-error *ngIf="form.get('iconName')?.hasError('required')">El icono es requerido</mat-error>
    </mat-form-field>

    <div class="color-row">
      <label>Color de fondo</label>
      <input type="color" formControlName="backgroundColor" class="color-input" />
      <span class="color-value">{{ form.get('backgroundColor')?.value }}</span>
    </div>

    <div class="image-row">
      <div class="image-preview" *ngIf="imagePreview">
        <img [src]="imagePreview" alt="imagen categoría" />
      </div>
      <button mat-stroked-button type="button" (click)="fileInput.click()">
        <mat-icon>upload</mat-icon>
        {{ imagePreview ? 'Cambiar imagen' : 'Subir imagen' }}
      </button>
      <input hidden type="file" accept="image/png,image/jpg,image/jpeg,image/webp" #fileInput
             (change)="onFileSelected($event)" />
    </div>

    <mat-checkbox formControlName="active">Categoría habilitada</mat-checkbox>

    <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button color="primary" (click)="save()">Guardar</button>
</mat-dialog-actions>
